export const getLocalDockerConfig = () => ({
  // gaia-server url
  serverUrl: 'http://localhost:915'
});
